import { Decision } from '@/shared/api/protocol-ts/model/dto_report_common_pb';
import { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';

import type { ConditionMarker } from '@/entities/condition';

import { conditionHasModelData } from './conditionHasModelData';

export const getConditionMarker = (
  condition: Condition,
  isChecked: boolean,
): ConditionMarker => {
  if (
    condition.Certainty &&
    condition.Certainty.UserDecision !== Decision.NoDecision
  ) {
    return 'manual';
  }

  if (isChecked) {
    return 'aiFound';
  }

  if (conditionHasModelData(condition.Certainty)) {
    return 'aiLowProbability';
  }

  return 'aiNotDetected';
};
